import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  Container,
  Flex,
  Heading,
  Stack,
} from "@chakra-ui/react";

import ArrowForwardIosRoundedIcon from "@material-ui/icons/ArrowForwardIosRounded";

// import User from "assets/profile.svg";
// import Bank from "assets/svg/icons-new/banks.svg";
// import Edit from "assets/svg/icons-new/edit.svg";
// import Support from "assets/svg/icons-new/support.svg";
// import Refer from "assets/svg/icons-new/refer.svg";
// import VerificationIcon from "../../../assets/svg/verification.svg";

//assets

// components
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";

// import AccountLink from "components/AccountLink/AccountLink";
import VerificationCard from "components/VerificationCard/VerificationCard";

// import { useIntercom } from "react-use-intercom";
// import ProfileShortInfo from "components/ProfileShortInfo/ProfileShortInfo";
import AccountSidebar from "components/AccountSidebar/AccountSidebar";
import {
  useGetBanksDetailsQuery,
  useGetLevel2StatusQuery,
} from "services/bankApi";

const isEmptyString = (val) => val === "" || val === undefined || val === null;

const AccountVerification = (props) => {
  // const { boot } = useIntercom();
  const userData = props.userData;

  // console.log("ACCOUNT VERIFICAATION PAGE PROPS", props);

  const {
    // data: bankDetails,
    isLoading: bankDetailsLoading,
    // error: bankDetailsError,
  } = useGetBanksDetailsQuery();

  const { data: level2Docs, isLoading: level2Loading } =
    useGetLevel2StatusQuery();

  // const level2Docs = undefined;

  console.log("BANK DETAILS", level2Docs);

  const getLevel1Status = () => {
    if (
      userData &&
      !isEmptyString(userData?.kycLevel) &&
      userData.kycLevel === "one"
    )
      return "approved";
    if (userData && userData.phoneVerified && userData.emailVerified)
      return "approved";
    return null;
  };

  const getLevel3Status = () => {
    if (
      userData &&
      !isEmptyString(userData?.kycLevel) &&
      userData.kycLevel === "one"
    )
      return null;
    if (
      userData &&
      !isEmptyString(userData?.kycLevel) &&
      userData.kycLevel === "three"
    )
      return "approved";

    const level3 = level2Docs?.find((d) => d?.kycLevel === "three");
    if (!level3) return null;
    if (level3?.kycLevel === "three" && userData?.kycLevel !== "three")
      return null;

    return level3?.status;
  };

  // console.log("verification data", {
  //   userData,
  //   level2Docs,
  //   getLevel3Status: getLevel3Status(),
  // });

  const getLevel2Status = () => {
    if (
      userData &&
      !isEmptyString(userData?.kycLevel) &&
      (userData.kycLevel === "two" || userData.kycLevel === "three")
    )
      return "approved";
    const level2 = level2Docs?.find((d) => d?.kycLevel === "two");
    if (!level2) return null;
    return level2?.status;
  };

  // console.log("LEVEL 2 DATA", level2Docs);

  // const bootWithProps = () =>
  //   boot({
  //     name: userData.firstName,
  //     userId: userData.userId,
  //     email: userData.email,
  //     phone: userData.phone || undefined,
  //     createdAt: userData.createdAt,
  //   });

  return (
    <Box>
      <Sidemenu currentPage="Account" logoutUser={props.logout} />
      <Header />
      <Box as="section">
        <div className="account-container">
          <Flex className="flex">
            <Box flex=".8" borderRight="1px solid #D9DBE9" position="sticky">
              <Container maxW="calc(100% - 2em)" ml="10px">
                <Stack mb="48px">
                  <Heading>Account</Heading>
                  <Breadcrumb
                    className="animate__animated animate__fadeInDown"
                    separator={
                      <ArrowForwardIosRoundedIcon
                        style={{ fontSize: ".8em", color: "#6E7191" }}
                      />
                    }
                  >
                    <BreadcrumbItem>
                      <BreadcrumbLink to="/dashboard/account">
                        Account
                      </BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbItem isCurrentPage>
                      <BreadcrumbLink isCurrentPage to="">
                        Verification
                      </BreadcrumbLink>
                    </BreadcrumbItem>
                  </Breadcrumb>
                </Stack>

                <AccountSidebar
                  current="verification"
                  userData={userData}
                  logout={props.logout}
                />
              </Container>
            </Box>

            <Box flex="1" mt={{ sm: "30px", lg: "60px" }}>
              <Container
                maxW={
                  {
                    // sm: "calc(100% - 13em)",
                    // lg: "calc(100% - 13em)",
                    // xl: "calc(100% - 20em)",
                  }
                }
                ml={{ lg: "60px" }}
                className="container"
              >
                <Stack gridGap="20px" padding={"1rem"}>
                  <VerificationCard
                    level={1}
                    disabled={
                      isEmptyString(userData?.kycLevel) ||
                      !(userData.phoneVerified && userData.emailVerified)
                    }
                    status={getLevel1Status()}
                  />
                  <VerificationCard
                    level={2}
                    isLoading={level2Loading}
                    status={getLevel2Status()}
                    disabled={
                      isEmptyString(userData?.kycLevel) || level2Loading
                    }
                    // status={userData.kycLevel === "two" ? "approved" : ""}
                    to="/dashboard/account/verification/level2"
                  />
                  <VerificationCard
                    isLoading={bankDetailsLoading}
                    disabled={
                      isEmptyString(userData?.kycLevel) ||
                      userData.kycLevel === "one" ||
                      userData.kycLevel === "three"
                    }
                    status={getLevel3Status()}
                    // status={userData.kycLevel === "three" ? "approved" : ""}
                    to="/dashboard/account/verification/level3"
                    level={3}
                  />
                </Stack>
              </Container>
            </Box>
          </Flex>
        </div>
      </Box>
    </Box>
  );
};

export default AccountVerification;
